import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {FORGE_VIEWER_TYPE_NO_PANEL} from "../../../constants/general-constants";
import {
  faFolder,
  faFilePdf,
  faChevronRight,
  faChevronDown,
  faCubes
} from "@fortawesome/free-solid-svg-icons";
import PreviewModal from "./PreviewModal";

export default function DocumentsPanel({ onOpenForge }) {

  const [selectedFolder, setSelectedFolder] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [expandedFolders, setExpandedFolders] = useState({});

 

  const directoryData = [
    {
      name: "Drawings",
      children: [
        {
          name: "Floor Plans",
          files: [
            { name: "Ground Floor.pdf", url: "/docs/gf.pdf" },
            { name: "Level 1.pdf", url: "/docs/l1.pdf" }
          ],
          children: []
        },
        {
          name: "Fire Strategy",
          files: [
            { name: "Fire Zones.pdf", url: "/docs/fire.pdf" }
          ],
          children: []
        }
      ]
    },
    {
      name: "BIM Models",
      children: [],
      files: [
        { name: "NorthWing.ifc", url: "/docs/northwing.ifc" }
      ]
    },
    {
      name: "Reports",
      children: [],
      files: [
        { name: "Asbestos Report.pdf", url: "/docs/asbestos.pdf" },
        { name: "Condition Survey.pdf", url: "/docs/condition.pdf" }
      ]
    }
  ];

  // Dummy Revit models list (all open same URN for now)
  const revitModels = [
    {
      name: "Palestra House - Core Model",
      urn: "dXJuOmFkc2sud2lwZW1lYTpmcy5maWxlOnZmLkNMcVU3MWsxU0tHN3V2SE5wNXZGcnc_dmVyc2lvbj0x"
    },
    {
      name: "Palestra House - Level 02",
      urn: "dXJuOmFkc2sud2lwZW1lYTpmcy5maWxlOnZmLkNMcVU3MWsxU0tHN3V2SE5wNXZGcnc_dmVyc2lvbj0x"
    },
    {
      name: "Palestra House - MEP",
      urn: "dXJuOmFkc2sud2lwZW1lYTpmcy5maWxlOnZmLkNMcVU3MWsxU0tHN3V2SE5wNXZGcnc_dmVyc2lvbj0x"
    }
  ];

  const toggleFolder = (path) => {
    setExpandedFolders(prev => ({
      ...prev,
      [path]: !prev[path]
    }));
  };

  function FolderTree({ nodes, parentPath = "" }) {
    return nodes.map((node) => {
      const path = parentPath + "/" + node.name;
      const isExpanded = expandedFolders[path];

      return (
        <div key={path} style={{ marginBottom: "6px" }}>
          <div
            onClick={() => {
              toggleFolder(path);
              setSelectedFolder(node);
            }}
            style={{
              padding: "10px 12px",
              borderRadius: "10px",
              cursor: "pointer",
              fontWeight: 600,
              display: "flex",
              alignItems: "center",
              gap: "10px",
              background: selectedFolder?.name === node.name ? "#f4c400" : "#f9f9f9",
              color: selectedFolder?.name === node.name ? "#000" : "#222",
              boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
            }}
          >
            <FontAwesomeIcon
              icon={isExpanded ? faChevronDown : faChevronRight}
              style={{ color: "#666", fontSize: "12px" }}
            />

            <FontAwesomeIcon icon={faFolder} color="#f4c400" />
            {node.name}
          </div>

          {isExpanded && node.children && node.children.length > 0 && (
            <div style={{ marginLeft: "14px", marginTop: "6px" }}>
              <FolderTree nodes={node.children} parentPath={path} />
            </div>
          )}
        </div>
      );
    });
  }

  const container = {
    display: "flex",
    height: "100%",
    gap: "12px"
  };

  const folderPane = {
    width: "38%",
    borderRight: "1px solid #eee",
    paddingRight: "10px",
    overflowY: "auto"
  };

  const filePane = {
    width: "62%",
    paddingLeft: "10px",
    overflowY: "auto"
  };

  const fileItem = {
    padding: "10px 12px",
    borderRadius: "8px",
    cursor: "pointer",
    background: "#ffffff",
    marginBottom: "8px",
    border: "1px solid #eee",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.04)"
  };

  return (
    <>
      <div style={container}>
        {/* Folder Tree */}
        <div style={folderPane}>
          <FolderTree nodes={directoryData} />

          {/* Revit Models Folder */}
          <div style={{ marginTop: "14px" }}>
            <div
              style={{
                padding: "10px 12px",
                borderRadius: "10px",
                fontWeight: 700,
                display: "flex",
                alignItems: "center",
                gap: "10px",
                background: "#fff4cc",
                color: "#000",
                boxShadow: "0 2px 4px rgba(0,0,0,0.06)"
              }}
            >
              <FontAwesomeIcon icon={faCubes} color="#f4c400" />
              Revit Models
            </div>

            <div style={{ marginLeft: "10px", marginTop: "8px" }}>
              {revitModels.map((model, idx) => (
                <div
                  key={idx}
                  style={fileItem}
				  onClick={() => {
				    if (onOpenForge) {
				      onOpenForge({urn:model.urn, title:model.name, mode:FORGE_VIEWER_TYPE_NO_PANEL});
				    }
				  }}
                >
                  <FontAwesomeIcon icon={faCubes} color="#f4c400" />
                  {model.name}
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    style={{ marginLeft: "auto", color: "#999" }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Files */}
        <div style={filePane}>
          {selectedFolder && selectedFolder.files ? (
            selectedFolder.files.map((file, idx) => (
              <div
                key={idx}
                style={fileItem}
                onClick={() => setPreviewUrl(file.url)}
              >
                <FontAwesomeIcon icon={faFilePdf} color="#f4c400" />
                {file.name}
                <FontAwesomeIcon
                  icon={faChevronRight}
                  style={{ marginLeft: "auto", color: "#999" }}
                />
              </div>
            ))
          ) : (
            <div style={{ color: "#999", padding: "10px" }}>
              Select a folder to view files
            </div>
          )}
        </div>
      </div>

      {/* PDF Preview */}
      <PreviewModal
        url={previewUrl}
        onClose={() => setPreviewUrl(null)}
      />

     
	 
    </>
  );
}
